import { ENVIRONMENT } from "../../../../../../environment";
import { ResourceType } from "../../../../../../interfaces/general";
// import approvedScanImage from "../../../../../../assets/images/cp_approved-scan.png";
import approvedRejectImage from "../../../../../../assets/images/cp_approved-reject.png";
import { ReactComponent as InfoCircle } from "../../../../../../assets/images/icons/info-circle.svg";

const PublicLinkApproved = ({ approved }: { approved: ResourceType["cp_approved"] }) => {
    // if (approved === null)
    //     return (
    //         <div className="flex flex-col items-center gap-3">
    //             <img src={approvedScanImage} alt="approved" className="size-[200px]" />
    //             <p className="text-[#14142A] font-normal text-sm leading-7 text-center">
    //                 فایل شما درحال بررسی است، لطفا چند لحظه دیگر تلاش کنید. در صورت رعایت{" "}
    //                 <a href={`${ENVIRONMENT.landingBaseUrl}rules`} target="_blank" className="text-primary-600 font-bold underline" rel="noreferrer">
    //                     قوانین ابرهمراهی
    //                 </a>
    //                 ، می‌توانید لینک دسترسی بسازید.
    //             </p>
    //         </div>
    //     );

    return (
        <div className="flex flex-col items-center gap-3">
            <img src={approvedRejectImage} alt="approved" className="size-[200px]" />
            <div className="flex items-start justify-start gap-2 bg-red-200 p-3 rounded-[10px]">
                <InfoCircle className="mt-1 min-w-5 max-w-5 h-5" />
                <p className="text-[#14142A] font-normal text-sm leading-7">
                    متاسفانه به علت عدم رعایت{" "}
                    <a href={`${ENVIRONMENT.landingBaseUrl}rules`} target="_blank" className="text-primary-600 font-bold underline" rel="noreferrer">
                        قوانین ابرهمراهی
                    </a>
                    ، فایل شما مورد تایید ابرهمراهی نیست و نمی‌توانید لینک دسترسی برای آن ایجاد کنید.
                </p>
            </div>
        </div>
    );
};

export default PublicLinkApproved;
